import { Delete } from '@mui/icons-material'
import { Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import { DeleteItemProps } from './types'

export const DeleteItem = ({ setDialogOpen }: DeleteItemProps): JSX.Element => {
  const { t } = useTranslation('common')

  const handleDeleteDialog = (): void => {
    setDialogOpen(true)
  }

  return (
    <>
      <Divider sx={{ my: 1 }} />

      <ListItemButton
        data-cy='actions-delete'
        icon={<Delete data-cy='delete-icon' />}
        onClick={handleDeleteDialog}
        text={t('form.action.delete')}
      />
    </>
  )
}
